import React from 'react';
import styled from 'styled-components';
import {useNavigate} from 'react-router-dom'
import { CodeXml } from 'lucide-react'
import { breakpoints } from '@/layouts/breakpoints'

const StyledComp = styled.div`
  background: #ffffff;
  padding: 80px 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 64px;
  max-width: 1400px;
  margin: 0 auto;

  @media (max-width: ${breakpoints.medium}) {
    flex-direction: column;
  }

  .content {
    max-width: 520px;
  }

  .eyebrow {
    font-size: 13px;
    color: #8a8a8a;
    margin: 0 0 16px;
  }

  .heading {
    font-size: 36px;
    color: #111111;
    line-height: 1.2;
    margin: 0 0 16px;
  }

  .description {
    font-size: 12px;
    line-height: 1.6;
    color: var(--grey);
    margin: 0 0 32px;
  }

  .actions {
    display: flex;
    gap: 12px;
  }

  .btn {
    border-radius: 8px;
    padding: 12px 24px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    border: 1px solid transparent;
    transition: background 0.3s;
  }

  .btn-primary {
    background: #111111;
    color: #ffffff;
  }
  .btn-primary:hover {
    background: #333;
  }

  .btn-secondary {
    background: #ffffff;
    color: #111111;
  }
  .btn-secondary:hover {
    background: #eee;
  }

  .grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
    max-width: 700px;
    width: 100%;
  }

  .card {
    border: 1px solid #ececec;
    border-radius: 8px;
    width: 100%;
    height: 180px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 14px;
  }

  .card-icon {
    width: 52px;
    height: 52px;
    object-fit: contain;
  }

  .card-label {
    font-size: 8px;
    padding-top: 12px;
  }
`;

const integrations = [
  { name: 'Sentry', icon: '/devs/sentry-icon.svg' },
  { name: 'CrowdStrike', icon: '/devs/crowdstrike-1.svg' },
  { name: 'Palo Alto', icon: '/devs/palo-alto-networks-svgrepo-com.svg' },
  { name: 'SentinelOne', icon: '/devs/S.svg' },
  { name: 'Datadog', icon: '/devs/datadog-icon.svg' },
  { name: 'Custom APIs' },
];

const SecuritySupport = () => {
  const navigate = useNavigate()
  return (
    <StyledComp>
      <div className="content">
        <p className="eyebrow">Integration</p>
        <h2 className="heading serif">Secure your financial data API across your stack</h2>
        <p className="description">
           AxionQuant connects to your SIEM, EDR, and cloud security tools through the
          market data SDK and MCP integrations. No rip-and-replace required.
        </p>
        <div className="actions">
          <button className="btn btn-primary" onClick={() => {navigate('/pricing')}} >Contact Sales</button>
          <button className="btn btn-secondary" onClick={() => {navigate('/docs')}} >Read Docs</button>
        </div>
      </div>

      <div className="grid">
        {integrations.map((item) => (
          <div className="card" key={item.name}>
            {item.icon ?
            <img className="card-icon" src={item.icon} alt={item.name} width="52" height="52" loading="lazy" />
              :
              <CodeXml width={52} height={52}/>
            }
            <span className="card-label sans">{item.name.toUpperCase()}</span>
          </div>
        ))}
      </div>
    </StyledComp>
  );
};

export default SecuritySupport;
